// extracted by mini-css-extract-plugin
module.exports = {"pointlistwrapper":"PointList_pointlistwrapper__l1ZaS","top":"PointList_top__XnRpJ","autogrid":"PointList_autogrid__X8DsY"};